import React, { ReactElement } from 'react';

// Define props for our Icon component
interface IconProps {
  name: string;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

// Map of icon names to their Font Awesome classes
const ICON_CLASSES: Record<string, string> = {
  // Dashboard icons
  'dashboard': 'fa fa-tachometer',
  'user': 'fa fa-user',
  'credit-card': 'fa fa-credit-card',
  'tools': 'fa fa-wrench',
  'print': 'fa fa-print',
  'book': 'fa fa-book',
  'graduation-cap': 'fa fa-graduation-cap',
  'calendar': 'fa fa-calendar',
  'question-circle': 'fa fa-question-circle',
  
  // Navigation icons
  'chevron-down': 'fa fa-chevron-down',
  'chevron-right': 'fa fa-chevron-right',
  'sign-out': 'fa fa-sign-out',
  'lock':'fa fa-lock',
  
  // Topbar icons
  'bell': 'fa fa-bell',
  'search': 'fa fa-search',
  'bars': 'fa fa-bars',
  'expand': 'fa fa-expand',
  'compress': 'fa fa-compress',
  'cog': 'fa fa-cog'
};

// Icon component that renders the appropriate Font Awesome icon based on name
const Icon = ({ name, size, className = '', style = {}, onClick }: IconProps): ReactElement | null => {
  // Get the icon class from our mapping
  const iconClass = ICON_CLASSES[name];
  
  if (!iconClass) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }
  
  // Set font size if provided
  const iconStyle = {
    ...style,
    fontSize: size ? `${size}px` : undefined
  };
  
  // Return a Font Awesome icon as an i element
  return <i className={`${iconClass} ${className}`} style={iconStyle} onClick={onClick} />;
};

export default Icon;
